import { useRef } from 'react';

export const SCROLL_TO_ELEMENT_BUFFER = 20;

export const useScrollToElement = (scrollTopOffset: number) => {
  const elementRef = useRef(null);

  const scrollToElement = () => {
    const scrollTop =
      elementRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      (scrollTopOffset + SCROLL_TO_ELEMENT_BUFFER);

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  };

  return { elementRef, scrollToElement };
};
